import React, { useEffect, useState } from "react";
import "../style/news.css";
import { Link, useParams } from "react-router";
import { convertToSlug, extractLastNumber, onError } from "../components/CommonFun";
import { GetApi } from "../api/api-service";
import { API_Path, companyName, imgBaseUrl } from "../Const";
import moment from "moment/moment";
import style from "../style/news.module.css";
import { ImageLoader } from "../components/loader/LoaderCommon";

function NewsDetails() {
    const paramsID = useParams();
    const [newsData, setNewsData] = useState([]);
    const [relatedData, setRelatedData] = useState([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        fatchNewsAndArticles();
        fatchRelatedNews();
    }, [paramsID]);

    const fatchNewsAndArticles = async () => {
        try {
            setLoader(true);
            let res = await GetApi(API_Path.fatchNewsAndArticles + `Details/${extractLastNumber(paramsID.id)}`);
            if (res && res.data.success) setNewsData(res.data.data);
            setLoader(false);
        } catch (error) {
            setLoader(false);
        }
    };
    const fatchRelatedNews = async () => {
        try {
            let res = await GetApi(API_Path.fatchNewsAndArticles + `Related/${extractLastNumber(paramsID.id)}`);
            if (res && res.data.success) setRelatedData(res.data.data);
        } catch (error) {}
    };
    return (
        <div className={style.our_blog_box}>
            <div className="container">
                <div className="our-blog-inner">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className={style.main_blog_content}>
                                <div className={`${style.blog_content}  ${style.blog_content_data}`}>
                                    <div className={style.blog_social}>
                                        <div className={`${style.blog_info_inner} blog-head-date`}>
                                            <span>By {companyName}</span>
                                            <span>{newsData[0]?.created ? moment(newsData[0]?.created, "DD-MM-YYYY hh:mm:ss A").format("DD MMM YYYY"):""}</span>
                                            {/* <span>{formatDateToShortMonth(newsData[0]?.created)}</span> */}
                                        </div>
                                        <h3>{newsData[0]?.title}</h3>
                                    </div>
                                    <div className={style.blog_img}>
                                        {loader ? <ImageLoader height="300px" /> : <img src={`${imgBaseUrl}${newsData[0]?.filePath}`} alt={newsData[0]?.title} onError={onError} />}
                                        {/* <div className="blog_tag">Lifestyle</div> */}
                                        <div dangerouslySetInnerHTML={{ __html: newsData[0]?.description }}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {relatedData && relatedData.length > 0 && (
                            <div className="col-lg-3">
                                <div className="blog-right">
                                    <div className={style.featured_items_sec}>
                                        <h3 className={style.title}>Related Articles</h3>
                                        {relatedData.map((item, i) => (
                                            <div className="featured-items-inner" key={i}>
                                                <div className="featured-items-img">
                                                    <img src={imgBaseUrl + item?.filePath} alt={item.title} onError={onError} />
                                                </div>
                                                <div className={style.featured_items}>
                                                    <div className="tooltip-wrapper">
                                                        <Link to={`/news/${convertToSlug(item.title)}-${item.id}`}>
                                                            <h3 className="tooltip-text tooltip-text-location">{item?.title}</h3>
                                                        </Link>
                                                    </div>
                                                    <div className={style.featured_items_info}>
                                                        <div className="read-more-btn">By {companyName}</div>
                                                        <div className="blog-ftr-details">
                                                            <span>{moment(item?.created, "DD-MM-YYYY hh:mm:ss A").format("DD MMM YYYY")}</span>
                                                            {/* <span>{formatDateToShortMonth(item?.created)}</span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NewsDetails;
